import React, { useEffect, useState } from "react";
import Latest_updates_content from "./latest_updates_content/Latest_updates_content";
import Relevent_news_update from "./relevent_news_update/Relevent_news_update";
import { useLocation, useParams } from "react-router-dom";
import { luxuryLatestNews, luxuryLatestNewsSigle } from "../../../../utils/luxuryapis/Home/Homeapi";

function Latest_updates_detials() {
  const { id } = useParams();
  const [news, setNews] = useState(null);

 const getAllLuxuryLatestNews = async () => {
     const res = await luxuryLatestNewsSigle(id);
     if (res?.success) {
       setNews(res?.data);
     } else {
       console.error("Error fetching  data:", res?.error);
     }
   };
    useEffect(() => {
       getAllLuxuryLatestNews();
     }, [id]);

  if (!news) return <p>Loading...</p>;

  return (
    <section className="Latest_updates_detials">
      <Latest_updates_content news={news} />
      <Relevent_news_update currentId={id} />
    </section>
  );
}

export default Latest_updates_detials;
